<template>
    <div class="main-admin-view">
        <v-list class="ma-auto mt-8 links-list font-weight-bold"
                dense>
            <v-list-item link
                         color="primary"
                         :to="{ name: 'usersAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="deep-orange">mdi-account</v-icon>
                </template>

                <v-list-item-title>Пользователи ({{usersCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'groupsAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="success">mdi-account-multiple</v-icon>
                </template>

                <v-list-item-title>Группы ({{groupsCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'groupsAndUsersAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="orange">mdi-account-group</v-icon>
                </template>

                <v-list-item-title>Члены групп ({{groupsAndUsersCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'invitationsAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="info">mdi-ticket</v-icon>
                </template>

                <v-list-item-title>Приглашения ({{invitationsCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'authorsAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="error">mdi-account-cowboy-hat</v-icon>
                </template>

                <v-list-item-title>Авторы ({{authorsCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'citationsAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="info">mdi-text-box-outline</v-icon>
                </template>

                <v-list-item-title>Цитаты ({{citationsCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'sportsAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="orange">mdi-tennis</v-icon>
                </template>

                <v-list-item-title>Спорт ({{sportsCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'hobbiesAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="success">mdi-telescope</v-icon>
                </template>

                <v-list-item-title>Хобби ({{hobbiesCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'foodAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="deep-orange">mdi-food-turkey</v-icon>
                </template>

                <v-list-item-title>Блюда ({{foodCount}})</v-list-item-title>
            </v-list-item>

            <v-list-item link
                         color="primary"
                         :to="{ name: 'dessertsAdminPage' }"
                         exact>
                <template v-slot:prepend>
                    <v-icon color="error">mdi-cake-variant</v-icon>
                </template>

                <v-list-item-title>Десерты ({{dessertsCount}})</v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
    export default {
        components: {

        },

        data() {
            return {
            };
        },

        created() {
            this.$store.dispatch("admin/loadTablesInfo");
        },

        computed: {
            usersCount() {
                return this.$store.state.admin.tablesInfo?.usersCount ?? "Нет данных";
            },

            groupsCount() {
                return this.$store.state.admin.tablesInfo?.groupsCount ?? "Нет данных";
            },

            groupsAndUsersCount() {
                return this.$store.state.admin.tablesInfo?.groupsAndUsersCount ?? "Нет данных";
            },

            invitationsCount() {
                return this.$store.state.admin.tablesInfo?.invitationsCount ?? "Нет данных";
            },

            authorsCount() {
                return this.$store.state.admin.tablesInfo?.authorsCount ?? "Нет данных";
            },

            citationsCount() {
                return this.$store.state.admin.tablesInfo?.citationsCount ?? "Нет данных";
            },

            sportsCount() {
                return this.$store.state.admin.tablesInfo?.sportsCount ?? "Нет данных";
            },

            hobbiesCount() {
                return this.$store.state.admin.tablesInfo?.hobbiesCount ?? "Нет данных";
            },

            foodCount() {
                return this.$store.state.admin.tablesInfo?.foodCount ?? "Нет данных";
            },

            dessertsCount() {
                return this.$store.state.admin.tablesInfo?.dessertsCount ?? "Нет данных";
            }
        },

        watch: {

        },

        methods: {

        }
    };
</script>

<style lang="scss">
    .main-admin-view .links-list {
        width: 400px;
        font-size: 40px;
    }

    .main-admin-view .links-list {
        width: 400px;
    }

    .main-admin-view .links-list .v-list-item .v-icon {
        font-size: 50px;
    }

    .main-admin-view .links-list .v-list-item .v-list-item-title {
        font-size: 20px;
        line-height: 3.5rem;
        font-weight: bold;
    }
</style>